





























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'



    class AmountListRequest extends PageRequest {
        orderNumber: string;
    }


    @Component({
        name:"amountList",
    })
    export default class Orders extends AbpBase {
        pagerequest: AmountListRequest = new AmountListRequest();
        get list() {
            return this.$store.state.fontamount.list;
        };
        get loading() {
            return this.$store.state.fontamount.loading;
        }
        pageChange(page: number) {
            this.$store.commit('fontamount/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('fontamount/setPageSize', pagesize);
            this.getpage();
        }
        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'fontamount/getAll',
                data: this.pagerequest
            });
        }
        get pageSize() {
            return this.$store.state.fontamount.pageSize;
        }
        get totalCount() {
            return this.$store.state.fontamount.totalCount;
        }
        get currentPage() {
            return this.$store.state.fontamount.currentPage;
        }
        async searchPage() {
            this.$store.state.fontamount.currentPage=1;
            this.getpage();
        }
        columns = [
             {
                title: '渠道',
                width: 150,
                align:"center",
                key: 'channel',
                render: (h: any, params: any) => {
                    return h('span', Enums.UserAmountChannel.filter(function (item) { return item.value == params.row.channel })[0].name);
                }
            },
            {
                title: '仓库名称',
                key: 'warehouseName',
                align:"center",
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.warehouseName ? params.row.warehouseName : params.row.storeName);
                }
            }, {
                title: '订单编号',
                key: 'orderNumber',
                align:"center",
                width: 250,
            }, {
                title: '创建时间',
                key: 'createTime',
                align:"center",
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            }, {
                title: '积分',
                align:"center",
                key: 'incurredAmount',
                render: (h: any, params: any) => {
                    return h('span', params.row.incurredAmount>0?("+"+params.row.incurredAmount):params.row.incurredAmount);
                }
            }, {
                title: '剩余积分',
                align:"center",
                key: 'balance',
            }]
        async created() {
            this.getpage();
        }
    }
